import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { Review } from '../types';
import { format } from 'date-fns';

interface ReviewCardProps {
  review: Review;
  index?: number;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ review, index = 0 }) => {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star 
        key={i}
        size={14} 
        className={i < rating ? 'text-amber-400 fill-amber-400' : 'text-gray-300'} 
      />
    ));
  };

  const formatDate = (date: Date | string) => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return format(dateObj, 'dd/MM/yy');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
      className="bg-white rounded-xl p-4 border border-gray-100"
    >
      <div className="flex items-start space-x-3">
        {/* Avatar */}
        {review.customerImage ? (
          <img
            src={review.customerImage}
            alt={review.customerName}
            className="w-10 h-10 rounded-full object-cover flex-shrink-0"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-primary-dark flex items-center justify-center flex-shrink-0">
            <span className="text-white font-medium text-sm">
              {review.customerName.charAt(0).toUpperCase()}
            </span>
          </div>
        )}

        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <h4 className="font-medium text-prim-text">{review.customerName}</h4>
            <span className="text-xs text-gray-400">{formatDate(review.date)}</span>
          </div>

          {/* Stars */}
          <div className="flex items-center space-x-0.5 mb-2">
            {renderStars(review.rating)}
            <span className="ml-2 text-sm font-medium text-prim-text">
              {review.rating.toFixed(1)}
            </span>
          </div>

          {/* Comment */}
          <p className="text-sm text-gray-600 leading-relaxed">
            {review.comment}
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default ReviewCard;

